<div class="container">
  <div class="row mb-1">
    <div class="col-md-12 text-end">
      <button
      (click)="exportToExcel()"
      class="btn-shadow d-inline-flex align-items-center btn btn-primary"
      >Export To Excel</button>

      <button
        (click)="back()"
        class="backBtn btn-shadow d-inline-flex align-items-center btn btn-success"
        
      >
        <i class="fa fa-arrow-circle-left mr-5"></i> Back
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">
          Packer Mover Request Details
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-3">
              <label for="">ID </label>
              <input
                type="text"
                [ngModel]="packerMoverList?._id"
                class="form-control"
                placeholder="ID"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Created On </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.createdOn | date : 'dd MMM yyyy'"
                class="form-control"
                placeholder="Created on"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2">
              <label for="">Moving Date </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.shiftingDate"
                class="form-control"
                placeholder="Moving Date"
                [disabled]="true"
              />
            </div>
            <div class="col-md-3">
              <label for="">Package ID </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.packageID"
                class="form-control"
                placeholder="Package ID"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Name </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.senderName"
                class="form-control"
                placeholder="Name"
                [disabled]="true"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">Mobile </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.senderMobile"
                class="form-control"
                placeholder="Mobile"
                [disabled]="true"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">Status </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.status == 1 ? 'Active' : 'Inactive'"
                class="form-control"
                placeholder="Status"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Pick Up Locaton </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.fromAddress"
                class="form-control"
                placeholder="Pick Up location"
                [disabled]="true"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">Pick Up Parking Distance </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.fromAddressPackageDistance"
                class="form-control"
                placeholder="Pick up parking distance"
                [disabled]="true"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">Pick Time </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.pickupTime"
                class="form-control"
                placeholder="Pick up time"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Drop Locaton </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.toAddress"
                class="form-control"
                placeholder="Drop location"
                [disabled]="true"
              />
            </div>
            <div class="col-md-4 mt-2">
              <label for="">Drop Parking Distance </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.toAddressPackageDistance"
                class="form-control"
                placeholder="Drop parking distance"
                [disabled]="true"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">Drop Time </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.dropTime"
                class="form-control"
                placeholder="Drop time"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Pick Up Service Lift </label>
              <input
                type="text"
                [ngModel]="
                  packerMoverList?.fromAddressServiceLeft == true
                    ? 'Available'
                    : 'Not Availabe'
                "
                class="form-control"
                placeholder="Pick up service lift"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2 mt-2">
              <label for="">Pick Up Floor No </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.fromAddressFloorNo"
                class="form-control"
                placeholder="Pick up floor no"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2 mt-2">
              <label for="">Drop Floor No </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.toAddressFloorNo"
                class="form-control"
                placeholder="Drop floor no"
                [disabled]="true"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">Drop Service Lift </label>
              <input
                type="text"
                [ngModel]="
                  packerMoverList?.toAdressServiceLeft == true
                    ? 'Available'
                    : 'Not Availabe'
                "
                class="form-control"
                placeholder="Drop service lift"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>

            <div class="col-md-1"></div>
            <div class="col-md-3 mt-2">
              <label for="">Total items </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.totalItemCount"
                class="form-control"
                placeholder="Total items"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2 mt-2">
              <label for="">Package Type </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.packageName"
                class="form-control"
                placeholder="Package type"
                [disabled]="true"
              />
            </div>
            <div class="col-md-2 mt-2">
              <label for=""
                >Booking Amount ( <i class="fa fa-inr"></i> )
              </label>
              <input
                type="text"
                [ngModel]="packerMoverList?.paymentDetails.totalAmount"
                class="form-control"
                placeholder="Package type"
                [disabled]="true"
              />
            </div>
            <div class="col-md-3 mt-2">
              <label for="">Payment Status </label>
              <input
                type="text"
                [ngModel]="
                  packerMoverList?.paymentDetails.status == 1
                    ? 'Done'
                    : 'Pending'
                "
                class="form-control"
                placeholder="Drop time"
                [disabled]="true"
              />
            </div>
            <div class="col-md-1"></div>
          </div>

          <br />
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10 packers_tab">
              <h2>Furniture Data</h2>
              <div class="mt-3 mb-3">
                <span
                  [ngClass]="
                    selectedValue_furniture == 'SOFA' ? 'text-success' : ''
                  "
                  (click)="selectFurniture('SOFA')"
                  >Sofa</span
                >
                <span
                  [ngClass]="
                    selectedValue_furniture == 'BED' ? 'text-success' : ''
                  "
                  (click)="selectFurniture('BED')"
                  >Bed</span
                >
                <span
                  [ngClass]="
                    selectedValue_furniture == 'MATTERS' ? 'text-success' : ''
                  "
                  (click)="selectFurniture('MATTERS')"
                  >Matters</span
                >
                <span
                  [ngClass]="
                    selectedValue_furniture == 'TABLES' ? 'text-success' : ''
                  "
                  (click)="selectFurniture('TABLES')"
                  >Tables</span
                >
                <span
                  [ngClass]="
                    selectedValue_furniture == 'CHAIRS' ? 'text-success' : ''
                  "
                  (click)="selectFurniture('CHAIRS')"
                  >Chairs</span
                >
                <span
                  [ngClass]="
                    selectedValue_furniture == 'ALMIRAH' ? 'text-success' : ''
                  "
                  (click)="selectFurniture('ALMIRAH')"
                  >Almirah</span
                >
                <span
                  [ngClass]="
                    selectedValue_furniture == 'ACCESSORIES'
                      ? 'text-success'
                      : ''
                  "
                  (click)="selectFurniture('ACCESSORIES')"
                  >Accessories</span
                >
              </div>
              <div class="main-card mb-3 card">
                <div class="table-responsive">
                  <table
                    class="align-middle mb-0 table table-borderless table-striped table-hover"
                    id="excel-table"
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Qty</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="selectedValue_furniture == 'SOFA'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Sofa;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_furniture == 'BED'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Bed;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_furniture == 'MATTERS'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Matters;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_furniture == 'TABLES'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Tables;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_furniture == 'CHAIRS'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Chairs;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_furniture == 'ALMIRAH'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Almirah;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_furniture == 'ACCESSORIES'">
                      <tr
                        *ngFor="
                          let data of furniture?.subItems.Accessories;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="!packerMoverList?.furniture">
                      <tr class="text-danger">
                        No Record Found
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10 packers_tab">
              <h2>Appliances Data</h2>
              <div class="mt-3 mb-3">
                <span
                  [ngClass]="
                    selectedValue_appliances == 'AC_COLLER_FAN'
                      ? 'text-success'
                      : ''
                  "
                  (click)="selectAppliances('AC_COLLER_FAN')"
                  >AC Cooler Fan</span
                >
                <span
                  [ngClass]="
                    selectedValue_appliances == 'BATHROOM_UTILITY'
                      ? 'text-success'
                      : ''
                  "
                  (click)="selectAppliances('BATHROOM_UTILITY')"
                  >Bathroom Utility</span
                >
                <span
                  [ngClass]="
                    selectedValue_appliances == 'FRIDGE' ? 'text-success' : ''
                  "
                  (click)="selectAppliances('FRIDGE')"
                  >FRIDGE</span
                >
                <span
                  [ngClass]="
                    selectedValue_appliances == 'HOME_UTILITY'
                      ? 'text-success'
                      : ''
                  "
                  (click)="selectAppliances('HOME_UTILITY')"
                  >Home Utility</span
                >
                <span
                  [ngClass]="
                    selectedValue_appliances == 'KITCHEN_UTILITY'
                      ? 'text-success'
                      : ''
                  "
                  (click)="selectAppliances('KITCHEN_UTILITY')"
                  >Kitech Utility</span
                >
                <span
                  [ngClass]="
                    selectedValue_appliances == 'TV' ? 'text-success' : ''
                  "
                  (click)="selectAppliances('TV')"
                  >TV</span
                >
                <span
                  [ngClass]="
                    selectedValue_appliances == 'VEHICLE' ? 'text-success' : ''
                  "
                  (click)="selectAppliances('VEHICLE')"
                  >Vehicle</span
                >
              </div>
              <div class="main-card mb-3 card">
                <div class="table-responsive">
                  <table
                    class="align-middle mb-0 table table-borderless table-striped table-hover"
                    id="excel-table"
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Qty</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="selectedValue_appliances == 'AC_COLLER_FAN'">
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Ac_Cooler_Fan;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody
                      *ngIf="selectedValue_appliances == 'BATHROOM_UTILITY'"
                    >
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Bathroom_Utility;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_appliances == 'FRIDGE'">
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Fridge;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_appliances == 'HOME_UTILITY'">
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Home_Utility;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody
                      *ngIf="selectedValue_appliances == 'KITCHEN_UTILITY'"
                    >
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Kitchen_Utility;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_appliances == 'TV'">
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Tv;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_appliances == 'VEHICLE'">
                      <tr
                        *ngFor="
                          let data of appliances?.subItems.Vehicle;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="!packerMoverList?.appliances">
                      <tr class="text-danger">
                        No Record Found
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10 packers_tab">
              <h2>Cartons Data</h2>
              <div class="mt-3 mb-3">
                <span
                  [ngClass]="
                    selectedValue_cartons == 'CARTONS' ? 'text-success' : ''
                  "
                  (click)="selectCartons('CARTONS')"
                  >Cartons</span
                >
                <span
                  [ngClass]="
                    selectedValue_cartons == 'GUNNY_BAGS' ? 'text-success' : ''
                  "
                  (click)="selectCartons('GUNNY_BAGS')"
                  >Gunny Bags</span
                >
              </div>
              <div class="main-card mb-3 card">
                <div class="table-responsive">
                  <table
                    class="align-middle mb-0 table table-borderless table-striped table-hover"
                    id="excel-table"
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Qty</th>
                      </tr>
                    </thead>
                    <tbody *ngIf="selectedValue_cartons == 'CARTONS'">
                      <tr
                        *ngFor="
                          let data of cartons?.subItems.Cartons;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody *ngIf="selectedValue_cartons == 'GUNNY_BAGS'">
                      <tr
                        *ngFor="
                          let data of cartons?.subItems.Gunny_Bags;
                          let i = index
                        "
                      >
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ i + 1 }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">
                                  {{ data.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left flex2">
                                <div class="widget-heading">{{ data.qty }}</div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="!packerMoverList?.cartons">
                      <tr class="text-danger">
                        No Record Found
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
